export const AUTHORIZED_USER_IDS = [
  'auth0|5ccdb6c80cf8e210d3a10ace',
  'auth0|690092508a48d53043edd3bb',
  'auth0|682b3bca7f9ffb250503bf52',
  'auth0|677e406005c9e18443cb6986',
] as const;

export const isUserAuthorized = (
  userId: string | undefined,
  allowedUserIds: readonly string[]
): boolean => Boolean(userId && allowedUserIds.includes(userId));

export const canUserAccess = (
  userId: string | undefined,
  allowedUserIds?: readonly string[]
): boolean =>
  allowedUserIds === undefined || isUserAuthorized(userId, allowedUserIds);